<template>
    <div class="row">
        <template v-for="item in items"
                  v-if="false === checkHidden || true !== item.hidden">
            <div :key="'shopItem'+item.id"
                 class="col-12 col-sm-6 col-md-6 col-lg-4">
                <a :href="item.url">
                    <div class="wrapper-white mb-4">
                        <div class="wrapper-img d-flex justify-content-center align-items-center ">
                            <img :src="item.logo"
                                 :alt="item.name" class="">
                        </div>
                        <div class="p-3">
                        <span class="status-job -sale"
                              :style="{backgroundColor: item.badge.color}"
                              v-if="item.badge">{{item.badge.content}}</span>
                            <h5 class="mt-3 mb-3">{{item.name}}</h5>

                            <span class="link-orange text-decoration-none text-center mb-2"
                                  v-for="cat in item.categories"
                                  :key="'spanItem'+item.id+'category'+cat"
                                  v-if="categories[cat]">
                                {{categories[cat].name}}<br :key="'separatorItem'+item.id+'category'+cat">
                            </span>
                            <span v-if="item.working_hours"
                                  class="link-orange text-decoration-none mt-2 text-center">
                                <strong class="font-bold">{{tWorkingHours}}</strong>
                            </span>
                            <span v-if="item.working_hours"
                                  :key="'itemWorkingHoursKey'+key"
                                  class="link-orange text-decoration-none mt-2 text-center"
                                  v-for="(value, key) in item.working_hours">
                                    <span v-html="key"></span> <span v-html="value"></span>
                            </span>
                        </div>
                    </div>
                </a>
            </div>
        </template>
        <template v-if="items.length <= hiddenCnt && false==showFirstLoader">
            <h4 class="text-center w-100">{{tNoData}}</h4>
        </template>

        <div class="loader" v-if="showLoader||showFirstLoader">
            <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"
                 preserveAspectRatio="xMidYMid" class="lds-double-ring">
                <circle cx="50" cy="50"
                        fill="none"
                        stroke-linecap="round"
                        r="40"
                        :stroke="strokeColor"
                        stroke-width="4"
                        stroke-dasharray="62.83185307179586 62.83185307179586"
                        transform="rotate(107.463 50 50)">
                    <animateTransform attributeName="transform" type="rotate" calcMode="linear"
                                      values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s"
                                      repeatCount="indefinite"></animateTransform>
                </circle>
                <circle cx="50" cy="50"
                        :stroke="strokeColor"
                        fill="none"
                        stroke-linecap="round"
                        r="35"
                        stroke-width="4"
                        stroke-dasharray="54.97787143782138 54.97787143782138"
                        stroke-dashoffset="54.97787143782138"
                        transform="rotate(-107.463 50 50)">
                    <animateTransform attributeName="transform" type="rotate" calcMode="linear"
                                      values="0 50 50;-360 50 50" keyTimes="0;1" dur="1s" begin="0s"
                                      repeatCount="indefinite"></animateTransform>
                </circle>
            </svg>
        </div>
    </div>
</template>

<script>
  // todo laoder na perwuju zagruzku
  // todo laoder na sortirowku
  // TODO COLOR FROM CONFIG
  import {mapActions} from 'vuex'
  import * as appConfig from '@/config/AppConfig'

  export default {
    name: 'SearchContent',
    data () {
      return {
        strokeColor: appConfig.SHOP_COLOR,
        tNoData: appConfig.T_NO_DATA,
        hiddenCnt: 0,
        showLoader: false,
        showFirstLoader: true,
        tWorkingHours: appConfig.T_WORKING_HOURS,
        checkHiddenValue: false
      }
    },
    computed: {
      categories () {
        return this.$store.getters.getStoreVar('categories')
      },
      selectedCategories () {
        return this.$store.getters.getStoreVar('selectedCategories')
      },
      orderBy () {
        return this.$store.getters.getStoreVar('orderBy')
      },
      str () {
        return this.$store.getters.getStoreVar('str')
      },

      items: function () {
        this.showLoader = true
        let itemsObject = Object.assign({}, this.$store.getters.getStoreVar('items'))
        let selectedCategories = this.selectedCategories
        let thisOrderBy = this.orderBy
        let str = this.str

        let items = []
        Object.keys(itemsObject).map((key, index) => {
          let element = itemsObject[key]
          element.hidden = false
          items.push(element)
        })

        let isFilterCategories = undefined !== selectedCategories && selectedCategories !== null && selectedCategories.length > 0
        let isFilterStr = undefined !== str && str !== null && str.length > 0

        if (isFilterCategories === false && isFilterStr === false) {
          this.checkHidden = false
          this.hiddenCnt = 0
          return this.sortItems(items, thisOrderBy)
        }

        let hiddenCnt = 0
        for (let i = 0; i < items.length; i++) {
          let element = items[i]
          if (isFilterStr === true && element.name.toLowerCase().indexOf(str.toLowerCase()) < 0) {
            items[i].hidden = true
            hiddenCnt++
            continue
          }

          let categoriesFromItem = []
          if (undefined !== element.categories && element.categories !== null && element.categories.length > 0) {
            categoriesFromItem = element.categories
          }

          if (isFilterCategories === true && selectedCategories.some(e => categoriesFromItem.indexOf(e) > -1) === false) {
            items[i].hidden = true
            hiddenCnt++
          }
        }

        this.hiddenCnt = hiddenCnt
        this.checkHidden = true
        return this.sortItems(items, thisOrderBy)
      },
      checkHidden: {
        get () {
          return this.checkHiddenValue
        },
        set (val) {
          this.checkHiddenValue = val
        }
      }
    },
    methods: {
      ...mapActions(['getItems', 'setStoreVar']),
      sortItems (items, thisOrderBy) {
        // let thisOrderBy = this.orderBy
        if (thisOrderBy === 'titleAsc') {
          items.sort((a, b) => {
            let x = a.name.toLowerCase()
            let y = b.name.toLowerCase()
            return x < y ? -1 : x > y ? 1 : 0
          })
          this.hideLoader()
          return items
        }
        if (thisOrderBy === 'titleDesc') {
          items.sort((a, b) => {
            let x = a.name.toLowerCase()
            let y = b.name.toLowerCase()
            return x > y ? -1 : x < y ? 1 : 0
          })
          this.hideLoader()
          return items
        }
        if (thisOrderBy === 'promotion') {
          items.sort((a, b) => {
            let x = undefined === a.badge || a.badge === null ? 1 : 0
            let y = undefined === b.badge || b.badge === null ? 1 : 0
            return x < y ? -1 : x > y ? 1 : 0
          })
          this.hideLoader()
          return items
        }
        this.hideLoader()
        return items
      },
      hideLoader () {
        setTimeout(() => {
          this.showLoader = false
        }, 300)
      }
    },
    created () {
      this.getItems()
        .then((response) => {
          this.showFirstLoader = false
        })
    }
  }
</script>

<style scoped>
    .text-decoration-none {
        text-decoration: none !important;
    }

    strong {
        font-family: "Montserrat-Medium";
    }

    .loader {
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, .6);
        text-align: center;
        padding-top: 60px;
    }

    .loader svg {
        vertical-align: baseline;
        width: 100px;
        height: 100px;
        margin: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/SearchContent.vue